import { breakpoints } from '../foundations/breakpoints';
import { useWindowSize } from './use-window-size';

export const useIsSmall = (): boolean => {
  const { width } = useWindowSize();
  return !!(width && width <= breakpoints.s);
};

export const useIsMedium = (): boolean => {
  const { width } = useWindowSize();
  return !!(width && width >= breakpoints.m);
};
